import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleToggle = () => {
    setIsAnimating(true);
    setTheme(theme === "dark" ? "light" : "dark");
    setTimeout(() => setIsAnimating(false), 600);
  };

  if (!mounted) {
    return (
      <Button
        variant="ghost"
        size="icon"
        className="h-9 w-9 rounded-full"
      >
        <Sun className="h-5 w-5" />
      </Button>
    );
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={handleToggle}
      className="h-9 w-9 rounded-full hover:bg-accent/20 hover:scale-110 transition-all duration-300 relative overflow-hidden group"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-primary/0 via-primary/10 to-primary/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      
      {theme === "dark" ? (
        <Sun 
          className={`h-5 w-5 text-primary relative z-10 transition-all duration-500 ${
            isAnimating ? 'rotate-180 scale-125' : 'rotate-0 scale-100'
          }`} 
        />
      ) : (
        <Moon 
          className={`h-5 w-5 text-primary relative z-10 transition-all duration-500 ${
            isAnimating ? 'rotate-180 scale-125' : 'rotate-0 scale-100'
          }`} 
        />
      )}
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
